// import React from 'react'
// import './portfolio.css'
// import IMG1 from '../../images/mern.png'
// import IMG2 from '../../images/textHelper.png'
// import IMG3 from '../../images/planet.png'
// import IMG4 from '../../images/ml.jpeg'
//
// const Portfolio = () => {
//     return (
//         <section id='portfolio'>
//             <h5>My Recent Work</h5>
//             <h2>Projects</h2>
//
//             <div className="container portfolio__container">
//
//
//             <article className="portfolio__item">
//                     <div className="portfolio__item-image">
//                         <img src={IMG1} alt="" />
//                     </div>
//                     <h4>Hotel Management  System(C++, OOPs)</h4>
//                     <h5>• Designed and implemented an efficient hotel management system, streamlining operations and enhancing guest experiences through seamless reservation management, room assignment, and personalized service tracking.</h5>
//                     <div className="portfolio__item-cta">
//                         <a href="https://github.com/deepak2002139/Hotel-management-System" className='btn' target='_blank' rel="noreferrer noopener">GitHub</a>
//                         {/* <a href="https://mernankit.herokuapp.com/" className='btn btn-primary' target='_blank' rel="noreferrer noopener">Live Demo</a> */}
//                     </div>
//                 </article>
//
//
//                 <article className="portfolio__item">
//                     <div className="portfolio__item-image">
//                         <img src={IMG3} alt="" />
//                     </div>
//                     <h4>Hackbreeze(A COLLABORATIVE TOOL FOR DEVELOPERS)</h4>
//                     <h5>• It keeps track of the progress across various domains of programming and development.</h5>
//                     <h5>• Build a platform which tracks all the Upcoming Contests and Hackathons.</h5>
//                     <h5>• user will be notified of the contests and POTDs.</h5>
//                     <div className="portfolio__item-cta">
//                         <a href="https://github.com/deepak2002139/Hackbreeze" className='btn' target='_blank' rel="noreferrer noopener">GitHub</a>
//                         {/* <a href="https://github.com/deepak2002139/Hackbreeze" className='btn btn-primary' target='_blank' rel="noreferrer noopener">Live Demo</a> */}
//                     </div>
//                 </article>
//
//                 <article className="portfolio__item">
//                     <div className="portfolio__item-image">
//                         <img src={IMG2} alt="" />
//                     </div>
//                     <h4>Moviemania App</h4>
//                     <h5>• Moviemania is a React-based movie website that allows users to search for movies by title, sort them by genre, view trending and upcoming movies, and bookmark their favorite movies. The website is designed to be user-friendly and visually appealing.</h5>
//                     <div className="portfolio__item-cta">
//                         <a href="https://github.com/deepak2002139/Moviemania-app" className='btn' target='_blank' rel="noreferrer noopener">GitHub</a>
//                         <a href="https://vitejsvitexqecwd-xsdf--5173--7259293c.local-credentialless.webcontainer.io/" className='btn btn-primary' target='_blank' rel="noreferrer noopener">Live Demo</a>
//                     </div>
//                 </article>
//                 <article className="portfolio__item">
//                     <div className="portfolio__item-image">
//                         <img src={IMG4} alt="" />
//                     </div>
//                     <h4>Electricity-consuption-prediction-using-machine-learning</h4>
//                     <h5>• (Python, Pandas, Numpy,Matplotlib, Seaborn,Scikit-learn)</h5>
//                     <h5>• successfully implemented advanced ML algorithms. Achieved notable results, including a 0.9149 R2 score with Random Forest and an outstanding 0.9930 score with K Nearest Neighbors in power consumption predictions.</h5>
//                     <div className="portfolio__item-cta">
//                         <a href="https://github.com/deepak2002139/Electricity-consuption-prediction-using-machine-learning" className='btn' target='_blank' rel="noreferrer noopener">GitHub</a>
//                         {/* <a href="https://github.com/deepak2002139/Hackbreeze" className='btn btn-primary' target='_blank' rel="noreferrer noopener">Live Demo</a> */}
//                     </div>
//                 </article>
//
//
//             </div>
//         </section>
//     )
// }
//
// export default Portfolio
import React from 'react';
import './portfolio.css';
import IMG1 from '../../images/mern.png';
import IMG2 from '../../images/textHelper.png';
import IMG3 from '../../images/planet.png';
import IMG4 from '../../images/ml.jpeg';
import IMG5 from '../../images/ai-astro.png';

const Portfolio = () => {
  return (
    <section id='portfolio'>
      <h5>My Recent Work</h5>
      <h2>Projects</h2>

      <div className="container portfolio__container">
        <article className="portfolio__item">
          <div className="portfolio__item-image">
            <img src={IMG5} alt="AI Astro" />
          </div>
          <div className="portfolio__content">
            <h4>AI Astro (09/2025 - Present)</h4>
            <div className="portfolio__description">
              <p><strong>Tech Stack:</strong> LangGraph, ChromaDB, Python, FastAPI, Spring Boot, Java</p>
              <p>• Designed and implemented a Retrieval-Augmented Generation (RAG) system using LangGraph state machines, showcasing expertise in Agentic AI, Prompt Engineering, and self-improving AI workflows.</p>
              <p>• Applied advanced AI techniques including Semantic Search (ChromaDB), Multi-hop Retrieval, Query Decomposition, Confidence Scoring, and Automatic Validation to mitigate hallucinations and improve response reliability.</p>
              <p>• Engineered a microservices-based architecture separating business logic (Spring Boot/Java) from AI orchestration (Python/FastAPI), demonstrating strong AI systems design and architectural decision-making.</p>
            </div>
          </div>
          <div className="portfolio__item-cta">
            <a href="https://github.com/deepak2002139/AiAstro" className='btn' target='_blank' rel="noreferrer noopener">GitHub</a>
          </div>
        </article>

        <article className="portfolio__item">
          <div className="portfolio__item-image">
            <img src={IMG1} alt="Hotel Management System" />
          </div>
          <div className="portfolio__content">
            <h4>Hotel Management System (C++, OOPs)</h4>
            <div className="portfolio__description">
              <p>• Designed and implemented an efficient hotel management system, streamlining operations and enhancing guest experiences through seamless reservation management, room assignment, and personalized service tracking.</p>
            </div>
          </div>
          <div className="portfolio__item-cta">
            <a href="https://github.com/deepak2002139/Hotel-management-System" className='btn' target='_blank' rel="noreferrer noopener">GitHub</a>
          </div>
        </article>

        <article className="portfolio__item">
          <div className="portfolio__item-image">
            <img src={IMG3} alt="Hackbreeze" />
          </div>
          <div className="portfolio__content">
            <h4>Hackbreeze (A COLLABORATIVE TOOL FOR DEVELOPERS)</h4>
            <div className="portfolio__description">
              <p>• It keeps track of the progress across various domains of programming and development.</p>
              <p>• Build a platform which tracks all the Upcoming Contests and Hackathons.</p>
              <p>• User will be notified of the contests and POTDs.</p>
            </div>
          </div>
          <div className="portfolio__item-cta">
            <a href="https://github.com/deepak2002139/Hackbreeze" className='btn' target='_blank' rel="noreferrer noopener">GitHub</a>
          </div>
        </article>

        <article className="portfolio__item">
          <div className="portfolio__item-image">
            <img src={IMG2} alt="Moviemania App" />
          </div>
          <div className="portfolio__content">
            <h4>Moviemania App</h4>
            <div className="portfolio__description">
              <p>• Moviemania is a React-based movie website that allows users to search for movies by title, sort them by genre, view trending and upcoming movies, and bookmark their favorite movies.</p>
            </div>
          </div>
          <div className="portfolio__item-cta">
            <a href="https://github.com/deepak2002139/Moviemania-app" className='btn' target='_blank' rel="noreferrer noopener">GitHub</a>
            <a href="https://vitejsvitexqecwd-xsdf--5173--7259293c.local-credentialless.webcontainer.io/" className='btn btn-primary' target='_blank' rel="noreferrer noopener">Live Demo</a>
          </div>
        </article>

        <article className="portfolio__item">
          <div className="portfolio__item-image">
            <img src={IMG4} alt="Electricity Consumption Prediction" />
          </div>
          <div className="portfolio__content">
            <h4>Electricity-consumption-prediction-using-machine-learning</h4>
            <div className="portfolio__description">
              <p>• (Python, Pandas, Numpy, Matplotlib, Seaborn, Scikit-learn)</p>
              <p>• Successfully implemented advanced ML algorithms. Achieved notable results, including a 0.9149 R2 score with Random Forest and an outstanding 0.9930 score with K Nearest Neighbors in power consumption predictions.</p>
            </div>
          </div>
          <div className="portfolio__item-cta">
            <a href="https://github.com/deepak2002139/Electricity-consuption-prediction-using-machine-learning" className='btn' target='_blank' rel="noreferrer noopener">GitHub</a>
          </div>
        </article>
      </div>
    </section>
  )
}

export default Portfolio;
